module.exports = __webpack_public_path__ + "static/media/wallpaper-salary-highway@2x.295cc836.png";